/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class FinAiAgentAnalyzeMonitorEditConversationsReviewIssueRoute extends Route {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.analyze.monitor.edit.conversations.review.issue',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(FinAiAgentAnalyzeMonitorEditConversationsReviewIssueRoute);
